// @flow
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CORE_GET_COMMON_I18N } from 'Utils/request/requestDictionary';
import { MEDIA_THUMBNAIL } from 'Client/cms/toolkit/constants';
import { MediaThumbnailLine } from 'Components/lines/media-thumbnail-line/MediaThumbnailLine.jsx';

export const mediaThumbnailDescriptor = {
  name: MEDIA_THUMBNAIL,
  component: MediaThumbnailLine,
  resolve(appContext: AppContext) {
    const query = `query {
      config {
        common { close }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: CORE_GET_COMMON_I18N,
      strictErrors: false,
    });
  },
};
